<template>
  <div class="relative size-full">
    <GoogleMap
      v-if="lat && lng && mapsKey && mapsId"
      :api-key="mapsKey"
      class="size-full"
      :center="center"
      v-bind="options"
      :zoom="15"
      :map-id="mapsId"
    >
      <AdvancedMarker :options="markerOptions" />
    </GoogleMap>
    <iframe
      v-else
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d841.0934458303387!2d8.534356610561462!3d47.38058975862068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47900a0e5cfd7ee3%3A0x2430ca0fee88fd32!2sGEMINI%20Sammelstiftung!5e0!3m2!1sde!2sch!4v1753267708530!5m2!1sde!2sch"
      title="GEMINI Sammelstiftung Map"
      width="100%"
      height="100%"
      style="border:0;"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"
    />
  </div>
</template>

<script lang="ts" setup>
// import MapStyle from '~/assets/utils/MapStyle'
import { GoogleMap, AdvancedMarker } from 'vue3-google-map'

const props = defineProps<{
  lat: string | null
  lng: string | null
}>()

const config = useRuntimeConfig()
const mapsKey = config.public.GMAPS_KEY
const mapsId = config.public.GMAPS_ID

const center = {
  lat: parseFloat(props.lat),
  lng: parseFloat(props.lng),
}

const options = {
  panControl: false,
  zoomControl: true,
  mapTypeControl: false,
  scaleControl: false,
  scrollwheel: false,
  streetViewControl: false,
  overviewMapControl: false,
  fullscreenControl: false,
  disableDefaultUi: false,
  rotateControl: false,
  // styles: MapStyle,
}

const markerOptions = {
  position: center,
  // icon: {
  //   url: '/maps-marker.png',
  //   scaledSize: { width: 30, height: 45, f: 'px', b: 'px' },
  // },
}
</script>
